import { trpc } from '@/plugins/trpc';
import { useMutation } from '@tanstack/vue-query';
import type { TRPCError } from '@trpc/server';
import type { ContactRequestParams } from '../../domain/schemas';

export const useSendContactForm = () => {
    return useMutation<void, TRPCError, ContactRequestParams>(['contactRequest'], data => trpc.postContactRequest.mutate(data));
};
